/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateCheckoutSessionDto,
  CurrentSubscriptionResponseDto,
  CustomerPortalResponseDto,
  ErrorResponse,
  TransactionPaginationDto,
} from '../models/index';
import {
    CreateCheckoutSessionDtoFromJSON,
    CreateCheckoutSessionDtoToJSON,
    CurrentSubscriptionResponseDtoFromJSON,
    CurrentSubscriptionResponseDtoToJSON,
    CustomerPortalResponseDtoFromJSON,
    CustomerPortalResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    TransactionPaginationDtoFromJSON,
    TransactionPaginationDtoToJSON,
} from '../models/index';

export interface AdminGetPracticeSubscriptionRequest {
    practiceId: string;
}

export interface AdminGetPracticeTransactionsRequest {
    practiceId: string;
    page?: number;
    pageSize?: number;
}

export interface CreateCheckoutSessionRequest {
    createCheckoutSessionDto: CreateCheckoutSessionDto;
}

export interface GetPracticeInvoicesRequest {
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class PracticePaymentApi extends runtime.BaseAPI {

    /**
     * Retrieve subscription details for a specific practice (Admin only)
     * Admin: Get Practice Subscription Details
     */
    async adminGetPracticeSubscriptionRaw(requestParameters: AdminGetPracticeSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentSubscriptionResponseDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling adminGetPracticeSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/admin/practices/{practiceId}/subscription`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentSubscriptionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve subscription details for a specific practice (Admin only)
     * Admin: Get Practice Subscription Details
     */
    async adminGetPracticeSubscription(requestParameters: AdminGetPracticeSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentSubscriptionResponseDto> {
        const response = await this.adminGetPracticeSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated transactions for a specific practice (Admin only)
     * Admin: Get Practice Transactions
     */
    async adminGetPracticeTransactionsRaw(requestParameters: AdminGetPracticeTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionPaginationDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling adminGetPracticeTransactions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/admin/practices/{practiceId}/transactions`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionPaginationDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated transactions for a specific practice (Admin only)
     * Admin: Get Practice Transactions
     */
    async adminGetPracticeTransactions(requestParameters: AdminGetPracticeTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionPaginationDto> {
        const response = await this.adminGetPracticeTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Stripe customer portal URL for canceling subscription
     * Create Customer Portal URL for Cancel Subscription
     */
    async createCancelSubscriptionUrlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerPortalResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/cancel-subscription-url`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerPortalResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Stripe customer portal URL for canceling subscription
     * Create Customer Portal URL for Cancel Subscription
     */
    async createCancelSubscriptionUrl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerPortalResponseDto> {
        const response = await this.createCancelSubscriptionUrlRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a Stripe checkout session for practice onboarding and subscription payment
     * Create Stripe Checkout Session
     */
    async createCheckoutSessionRaw(requestParameters: CreateCheckoutSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createCheckoutSessionDto'] == null) {
            throw new runtime.RequiredError(
                'createCheckoutSessionDto',
                'Required parameter "createCheckoutSessionDto" was null or undefined when calling createCheckoutSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/checkout-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCheckoutSessionDtoToJSON(requestParameters['createCheckoutSessionDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a Stripe checkout session for practice onboarding and subscription payment
     * Create Stripe Checkout Session
     */
    async createCheckoutSession(requestParameters: CreateCheckoutSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCheckoutSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Create Stripe customer portal URL for updating payment methods and billing information
     * Create Customer Portal URL for Payment Method Update
     */
    async createUpdatePaymentMethodUrlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerPortalResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/update-payment-method-url`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerPortalResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Stripe customer portal URL for updating payment methods and billing information
     * Create Customer Portal URL for Payment Method Update
     */
    async createUpdatePaymentMethodUrl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerPortalResponseDto> {
        const response = await this.createUpdatePaymentMethodUrlRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create Stripe customer portal URL for updating subscription
     * Create Customer Portal URL for Update Subscription
     */
    async createUpdateSubscriptionUrlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerPortalResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/update-subscription-url`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerPortalResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Stripe customer portal URL for updating subscription
     * Create Customer Portal URL for Update Subscription
     */
    async createUpdateSubscriptionUrl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerPortalResponseDto> {
        const response = await this.createUpdateSubscriptionUrlRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve current subscription details including plan, pricing, and renewal datetime
     * Get Current Subscription
     */
    async getCurrentSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentSubscriptionResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentSubscriptionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve current subscription details including plan, pricing, and renewal datetime
     * Get Current Subscription
     */
    async getCurrentSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentSubscriptionResponseDto> {
        const response = await this.getCurrentSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated list of subscription-related transactions for a practice with pagination
     * Get Practice Transactions
     */
    async getPracticeInvoicesRaw(requestParameters: GetPracticeInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionPaginationDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice-payment/transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionPaginationDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated list of subscription-related transactions for a practice with pagination
     * Get Practice Transactions
     */
    async getPracticeInvoices(requestParameters: GetPracticeInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionPaginationDto> {
        const response = await this.getPracticeInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process Stripe webhook events for payment notifications and subscription updates
     * Handle Stripe Webhook Events
     */
    async handleWebhookRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/practice-payment/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process Stripe webhook events for payment notifications and subscription updates
     * Handle Stripe Webhook Events
     */
    async handleWebhook(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.handleWebhookRaw(initOverrides);
    }

}
